module.exports = __webpack_public_path__ + "img/crystalheart_lp.455c405a.jpg";